import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentfaq from '../components/componentfaq'
import Cards from '../components/cards'
import Card from '../components/card'
import FooterMain from '../components/footer-main'
import './kolarc.css'

const Kolarc = (props) => {
  return (
    <div className="kolarc-container1">
      <Helmet>
        <title>
          Сварочные источники Kolarc | Официальный дистрибьютор | Arcobo
        </title>
        <meta
          name="description"
          content="Arcobo — официальный дистрибьютор сварочных источников Kolarc. Поставка оборудования MIG, TIG и MMA, техническая поддержка и интеграция в роботизированные комплексы."
        />
        <meta
          property="og:title"
          content="Сварочные источники Kolarc | Официальный дистрибьютор | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo — официальный дистрибьютор сварочных источников Kolarc. Поставка оборудования MIG, TIG и MMA, техническая поддержка и интеграция в роботизированные комплексы."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Сварочные источники Kolarc | Официальный дистрибьютор | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo — официальный дистрибьютор сварочных источников Kolarc. Поставка оборудования MIG, TIG и MMA, техническая поддержка и интеграция в роботизированные комплексы."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/kolarc"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/kolarc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Kolarc","item":"https://arcobo.tech/kolarc"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name1"></HeaderMain>
      <hr className="kolarc-separator1"></hr>
      <Componenttextimage
        image1Src="/1_Solution/1_2_2-Kolarc/kolarc-1500w.webp"
        image1Alt="Сварочные источники Kolarc"
        rootClassName="componenttextimageroot-class-name6"
        textComponent={
          <Fragment>
            <span className="kolarc-text100">
              <span className="kolarc-text101 H1_extrasmall">
                Современные цифровые сварочные источники для промышленной
                роботизации и ручной сварки
              </span>
              <br></br>
              <span>
                Kolarc - это линейка профессиональных сварочных источников с
                высокой стабильностью дуги, цифровым управлением параметрами и
                поддержкой удаленного мониторинга через Kolarc Cloud.
              </span>
              <br></br>
              <br></br>
              <span className="kolarc-text106 H1_small">
                Преимущества и выгоды:
              </span>
              <br></br>
              <span className="kolarc-text108">✔ </span>
              <span className="kolarc-text109 H1_extrasmall">
                Европейское качество
              </span>
              <br></br>
              <span>
                Высокая стабильность сварочного процесса, надежная элементная
                база и • производство в Европе.
              </span>
              <br></br>
              <span className="kolarc-text113">✔ </span>
              <span className="kolarc-text114 H1_extrasmall">
                Оптимальное соотношение цены и возможностей
              </span>
              <br></br>
              <span>
                Функциональность оборудования премиального уровня при
                значительно более доступной стоимости владения.
              </span>
              <br></br>
              <span className="kolarc-text118">✔</span>
              <span className="kolarc-text119 H1_extrasmall">
                Цифровая экосистема Kolarc Cloud
              </span>
              <br></br>
              <span>
                Удаленный мониторинг оборудования, анализ параметров сварки и
                диагностика через облачную платформу.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Сварочные источники Kolarc"
      ></Componenttextimage>
      <hr className="kolarc-separator2"></hr>
      <Component3images
        image1Src="/1_Solution/1_2_2-Kolarc/kolarc_21-200h.webp"
        image1Alt="Сварочные источники Kolarc"
        image2Src="/1_Solution/1_2_2-Kolarc/kolarc_22-200h.webp"
        image2Alt="Сварочные источники Kolarc"
        image3Src="/1_Solution/1_2_2-Kolarc/kolarc_23-200h.webp"
        image3Alt="Сварочные источники Kolarc"
        rootClassName="component3imagesroot-class-name12"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="kolarc-text122">
              Выбор зависит от материала, толщины металла, режима работы и
              требований к производительности. Для большинства производственных
              задач оптимальным решением являются цифровые полуавтоматы MIG/MAG
              с синергетическим управлением. Специалисты Arcobo помогают
              подобрать источник Kolarc под конкретное производство и технологию
              сварки.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="kolarc-text123">
              Kolarc сочетает европейское качество изготовления, современные
              цифровые алгоритмы управления дугой и конкурентоспособную
              стоимость. Оборудование обеспечивает стабильный сварочный процесс
              как при ручной сварке, так и при работе в составе роботизированных
              комплексов. Все современные модели поддерживают подключение к
              системе удаленного мониторинга Arcobo Welding Monitor.
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="kolarc-text124">
              В зависимости от серии оборудование поддерживает процессы MIG/MAG,
              импульсную MIG/MAG сварку, TIG DC, MMA, а также специализированные
              режимы для алюминия, нержавеющей стали и других материалов. Это
              позволяет использовать один источник для широкого спектра
              производственных задач.
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="kolarc-text125">
              Да. Сварочные источники Kolarc разработаны в том числе для
              промышленной роботизации и успешно интегрируются с роботами
              Kawasaki Robotics и других производителей. Arcobo выполняет полный
              цикл интеграции, настройки технологических режимов и запуска
              роботизированных сварочных комплексов.
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="kolarc-text126">
              Arcobo является официальным дистрибьютором Kolarc в Казахстане и
              странах Центральной Азии. Мы поставляем оборудование, выполняем
              пусконаладку, обучение персонала, гарантийное и послегарантийное
              обслуживание, а также обеспечиваем техническую поддержку на
              протяжении всего срока эксплуатации.
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="kolarc-text127">
              Да. Arcobo обеспечивает локальную техническую поддержку,
              диагностику, ремонт, поставку расходных материалов и запасных
              частей для оборудования Kolarc. Это позволяет значительно
              сократить время простоя оборудования и оперативно решать
              возникающие технические вопросы.
            </span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="kolarc-text128">
              Да. Линейка Kolarc включает модели с импульсными режимами MIG/MAG
              и TIG, предназначенные для высококачественной сварки алюминиевых,
              нержавеющих и высокопрочных сталей. Настройка синергетических
              программ обеспечивает стабильную дугу и высокое качество сварного
              соединения.
            </span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="kolarc-text129">
              Да. Современные сварочные источники Kolarc поддерживают
              подключение к Arcobo Welding Monitor. Система позволяет
              контролировать загрузку оборудования, параметры сварки,
              производительность операторов, расход материалов и получать
              уведомления о событиях в режиме реального времени.
            </span>
          </Fragment>
        }
        question1="Какой сварочный полуавтомат выбрать для производства?"
        question2="Чем сварочные источники Kolarc отличаются от других производителей?"
        question3="Какие процессы сварки поддерживают источники Kolarc?"
        question4="Можно ли подключить Kolarc к системе мониторинга сварочного производства?"
        question5="Где купить сварочные источники Kolarc в Казахстане?"
        question6="Есть ли сервис и запасные части в Казахстане?"
        question7="Подходят ли источники Kolarc для сварки алюминия и нержавеющей стали?"
        question8="Можно ли подключить Kolarc к системе мониторинга сварочного производства?"
        rootClassName="componentfaqroot-class-name7"
      ></Componentfaq>
      <hr className="kolarc-separator3"></hr>
      <Component3images
        image1Src="/1_Solution/1_2_2-Kolarc/kolarc_31-200h.webp"
        image1Alt="Сварочный источник Kolarc"
        image2Src="/1_Solution/1_2_2-Kolarc/kolarc_32-200h.webp"
        image2Alt="Сварочный источник Kolarc"
        image3Src="/1_Solution/1_2_2-Kolarc/kolarc_33-200h.webp"
        image3Alt="Сварочный источник Kolarc"
        rootClassName="component3imagesroot-class-name13"
      ></Component3images>
      <hr className="kolarc-separator4"></hr>
      <Cards
        text="Цифровые источники MIG/MAG с импульсным режимом для высококачественной сварки стали, нержавеющей стали и алюминия."
        text1={
          <Fragment>
            <span className="kolarc-text130">
              Цифровые источники MIG/MAG с импульсным режимом для
              высококачественной сварки стали, нержавеющей стали и алюминия.
            </span>
          </Fragment>
        }
        heading="Серия MX Pulse"
        heading1={
          <Fragment>
            <span className="kolarc-text131">Серия MX Pulse</span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name5"
      ></Cards>
      <div className="kolarc-container2">
        <Card
          text={
            <Fragment>
              <span className="kolarc-text132">
                <span>Ток: 600А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 4.490</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="kolarc-text141">MX600 Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_600_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 Pulse"
          rootClassName="cardroot-class-name29"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text142">
                <span>Ток: 600А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 5.113</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX600 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text151">MX600 W Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_600_w_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 W Pulse"
          rootClassName="cardroot-class-name35"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text152">
                <span>Ток: 500А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 3.809</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX500 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text161">MX500 Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_500_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 Pulse"
          rootClassName="cardroot-class-name34"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text162">
                <span>Ток: 500А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 4.385</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX500 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text171">MX500 W Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_500_w_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 W Pulse"
          rootClassName="cardroot-class-name33"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text172">
                <span>Ток: 400А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 3.665</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX400 Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text181">MX400 Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_400_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 400 Pulse"
          rootClassName="cardroot-class-name32"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text182">
                <span>Ток: 400А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 4.235</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX400 W Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text191">MX400 W Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_400_w_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 400 W Pulse"
          rootClassName="cardroot-class-name31"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text192">
                <span>Ток: 350А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 2.544</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX350 C Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text201">MX350 C Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_350_c_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 350 C Pulse"
          rootClassName="cardroot-class-name30"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text202">
                <span>Ток: 350А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 3.085</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX350 CW Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text211">MX350 CW Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_350_cw_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 350 Cw Pulse"
          rootClassName="cardroot-class-name26"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text212">
                <span>Ток: 300А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 2.145</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX300 C Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text221">MX300 C Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_300_c_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 300 C Pulse"
          rootClassName="cardroot-class-name28"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text222">
                <span>Ток: 300А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 2.145</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX220 C Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text231">MX220 C Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX/mx_220_c_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 220 C Pulse"
          rootClassName="cardroot-class-name27"
        ></Card>
      </div>
      <Cards
        text="MIG/MAG источники с синергетическим управлением и импульсом для быстрой настройки и стабильного качества сварки."
        text1={
          <Fragment>
            <span className="kolarc-text232">
              MIG/MAG источники с синергетическим управлением и импульсом для
              быстрой настройки и стабильного качества сварки.
            </span>
          </Fragment>
        }
        heading="Серия MX Synergic Pulse"
        heading1={
          <Fragment>
            <span className="kolarc-text233">Серия MX Synergic Pulse</span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name7"
      ></Cards>
      <div className="kolarc-container3">
        <Card
          text={
            <Fragment>
              <span className="kolarc-text234">
                <span>Ток: 600А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 4.295</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX600 Synergic Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text243">MX600 Synergic Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_600_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 Synergic Pulse"
          rootClassName="cardroot-class-name46"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text244">
                <span>Ток: 600А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 4.909</span>
              </span>
            </Fragment>
          }
          heading="MX600 W Synergic Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text252">
                MX600 W Synergic Pulse HP 5m
              </span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_600_w_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 W Synergic Pulse"
          rootClassName="cardroot-class-name47"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text253">
                <span>Ток: 500А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 3.614</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX500 Synergic Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text262">MX500 Synergic Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_500_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 Synergic Pulse"
          rootClassName="cardroot-class-name48"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text263">
                <span>Ток: 500А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 4.181</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX500 W Synergic Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text272">
                MX500 W Synergic Pulse HP 5m
              </span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_500_w_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 W Synergic Pulse"
          rootClassName="cardroot-class-name49"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text273">
                <span>Ток: 450А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 3.470</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX400 Synergic Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text282">MX400 Synergic Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_400_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 400 Synergic Pulse"
          rootClassName="cardroot-class-name50"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text283">
                <span>Ток: 450А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 4.031</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX400 W Synergic Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text292">
                MX400 W Synergic Pulse HP 5m
              </span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_400_w_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 400 W Synergic Pulse"
          rootClassName="cardroot-class-name51"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text293">
                <span>Ток: 350А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 2.153</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX350 C Synergic Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text302">MX350 C Synergic Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_350_c_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 350 C Synergic Pulse"
          rootClassName="cardroot-class-name52"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text303">
                <span>Ток: 350А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 2.695</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX350 CW Synergic Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text312">MX350 CW Synergic Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_350_cw_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 350 Cw Synergic Pulse"
          rootClassName="cardroot-class-name53"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text313">
                <span>Ток: 300А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 1.769</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX300 C Synergic Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text322">MX300 C Synergic Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_300_c_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 300 C Synergic Pulse"
          rootClassName="cardroot-class-name54"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text323">
                <span>Ток: 300А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 1.769</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX220 C Synergic Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text332">MX220 C Synergic Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Synergic/mx_220_c_synergic_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 220 C Synergic Pulse"
          rootClassName="cardroot-class-name55"
        ></Card>
      </div>
      <Cards
        text="MIG/MAG источники, оптимизированные для судостроения, тяжелого машиностроения и крупногабаритных металлоконструкций."
        text1={
          <Fragment>
            <span className="kolarc-text333">
              MIG/MAG источники, оптимизированные для судостроения, тяжелого
              машиностроения и крупногабаритных металлоконструкций.
            </span>
          </Fragment>
        }
        heading="Серия MX Shipyard Pulse"
        heading1={
          <Fragment>
            <span className="kolarc-text334">Серия MX Shipyard Pulse</span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name4"
      ></Cards>
      <div className="kolarc-container4">
        <Card
          text={
            <Fragment>
              <span className="kolarc-text335">
                <span>Ток: 600А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 4.051</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX600 Shipyard HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text344">MX600 Shipyard HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_600_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 Shipyard Pulse"
          rootClassName="cardroot-class-name36"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text345">
                <span>Ток: 600А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 4.654</span>
              </span>
            </Fragment>
          }
          heading="MX600 W Shipyard Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text353">
                MX600 W Shipyard Pulse HP 5m
              </span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_600_w_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 W Shipyard Pulse"
          rootClassName="cardroot-class-name37"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text354">
                <span>Ток: 500А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Воздух</span>
                <br></br>
                <span>Цена: € 3.370</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX500 Shipyard Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text363">MX500 Shipyard Pulse HP 5m</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_500_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 Shipyard Pulse"
          rootClassName="cardroot-class-name38"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text364">
                <span>Ток: 500А</span>
                <br></br>
                <span>Материал: 1.0 + 1.2 mm / Steel</span>
                <br></br>
                <span>Охлаждение: Вода</span>
                <br></br>
                <span>Цена: € 3.926</span>
                <br></br>
              </span>
            </Fragment>
          }
          heading="MX500 W Shipyard Pulse HP 5m"
          heading1={
            <Fragment>
              <span className="kolarc-text373">
                MX500 W Shipyard Pulse HP 5m
              </span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_500_w_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 W Shipyard Pulse"
          rootClassName="cardroot-class-name39"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text374">
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="HP Air Cooled"
          heading1={
            <Fragment>
              <span className="kolarc-text379">HP Air Cooled</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/hp_air_cooled-200w.webp"
          imageAlt="Охлаждающий блок Kolarc Air Cooled"
          rootClassName="cardroot-class-name41"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text380">
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="HP Liquid Cooled"
          heading1={
            <Fragment>
              <span className="kolarc-text385">HP Liquid Cooled</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/hp_liquid_cooled-200w.webp"
          imageAlt="Охлаждающий блок Kolarc Liquid Cooled"
          rootClassName="cardroot-class-name40"
        ></Card>
      </div>
      <Cards
        text="Универсальные источники TIG DC Pulse для высокоточной сварки нержавеющей стали, титана и других ответственных изделий"
        text1={
          <Fragment>
            <span className="kolarc-text386">
              Универсальные источники TIG DC Pulse для высокоточной сварки
              нержавеющей стали, титана и других ответственных изделий
            </span>
          </Fragment>
        }
        heading="Серия TX Pulse"
        heading1={
          <Fragment>
            <span className="kolarc-text387">Серия TX Pulse</span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name3"
      ></Cards>
      <div className="kolarc-container5">
        <Card
          text={
            <Fragment>
              <span className="kolarc-text388">
                <span>Ток: 400А</span>
                <br></br>
                <span>Цена: € 2.245</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="TX400 Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text395">TX400 Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/TX/tx_400_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc TX 400 Pulse"
          rootClassName="cardroot-class-name58"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text396">
                <span>Ток: 400А</span>
                <br></br>
                <span>Цена: € 2.881</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="TX400 W Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text403">TX400 W Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/TX/tx_400_w_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc TX 400 W Pulse"
          rootClassName="cardroot-class-name59"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text404">
                <span>Ток: 270А</span>
                <br></br>
                <span>Цена: € 1.484</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="TX270 Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text411">TX270 Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/TX/tx_270_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc TX 270 Pulse"
          rootClassName="cardroot-class-name60"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text412">
                <span>Ток: 270А</span>
                <br></br>
                <span>Цена: € 2.233</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="TX270 W Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text419">TX270 W Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/TX/tx_270_w_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc TX 270 W Pulse"
          rootClassName="cardroot-class-name61"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text420">
                <span>Ток: 220А</span>
                <br></br>
                <span>Цена: € 1,484</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="TX220 Pulse"
          heading1={
            <Fragment>
              <span className="kolarc-text427">TX220 Pulse</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/TX/tx_220_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc TX 220 Pulse"
          rootClassName="cardroot-class-name62"
        ></Card>
      </div>
      <Cards
        text="Компактные инверторные источники MMA (ручная дуговая сварка) для производственных, монтажных и ремонтных работ"
        text1={
          <Fragment>
            <span className="kolarc-text428">
              Компактные инверторные источники MMA (ручная дуговая сварка) для
              производственных, монтажных и ремонтных работ
            </span>
          </Fragment>
        }
        heading="Серия SX"
        heading1={
          <Fragment>
            <span className="kolarc-text429">Серия SX</span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name6"
      ></Cards>
      <div className="kolarc-container6">
        <Card
          text={
            <Fragment>
              <span className="kolarc-text430">
                <span>Ток: 400А</span>
                <br></br>
                <span>Цена: € 1.831</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="SX400"
          heading1={
            <Fragment>
              <span className="kolarc-text437">SX400</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_600_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 Shipyard Pulse"
          rootClassName="cardroot-class-name42"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text438">
                <span>Ток: 270А</span>
                <br></br>
                <span>Цена: € 1.249</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="SX270"
          heading1={
            <Fragment>
              <span className="kolarc-text445">SX270</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_600_w_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 600 W Shipyard Pulse"
          rootClassName="cardroot-class-name43"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="kolarc-text446">
                <span>Ток: 220А</span>
                <br></br>
                <span>Цена: € 1.249</span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading="SX220"
          heading1={
            <Fragment>
              <span className="kolarc-text453">SX220</span>
            </Fragment>
          }
          imageSrc="/1_Solution/1_2_2-Kolarc/MX_Shipyard/mx_500_shipyard_pulse-200w.webp"
          imageAlt="Сварочный источник Kolarc MX 500 Shipyard Pulse"
          rootClassName="cardroot-class-name44"
        ></Card>
      </div>
      <hr className="kolarc-separator5"></hr>
      <hr className="kolarc-separator6"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name2"></FooterMain>
    </div>
  )
}

export default Kolarc
